<div class="timeline">
  <h3 class="timeline__title">Declarações</h3>
  <ol class="timeline__list">
    @for (item of items(); track item.exerciseYear) {
      <li class="timeline__step">
        <button
          type="button"
          class="timeline__item"
          [class.timeline__item--active]="isSelected(item)"
          [class.timeline__item--awaiting]="item.status === 'awaiting'"
          [class.timeline__item--failed]="item.status === 'failed'"
          [disabled]="!canSelect(item)"
          [attr.aria-pressed]="isSelected(item)"
          (click)="selectYear.emit(item.calendarYear)">
          <span class="timeline__dot" aria-hidden="true"></span>
          <span class="timeline__year">{{ item.exerciseYear }}</span>
          <span class="timeline__caption">IRPF {{ item.exerciseYear }}</span>
          <span class="timeline__caption">Ano-calendário {{ item.calendarYear }}</span>
          @if (statusLabel(item.status, item.exerciseYear); as status) {
            <span class="timeline__caption timeline__status">{{ status }}</span>
          } @else {
            <span class="timeline__caption">{{ kindLabel(item.kind) }}</span>
            @if (item.deliveredAt) {
              <span class="timeline__caption">{{ item.deliveredAt | vaultDate }}</span>
            }
          }
        </button>
      </li>
    }
  </ol>
  <!-- Legenda curta numa linha (R4-4); a explicação inteira fica no title. -->
  <p
    class="timeline__note"
    title="Cada nova declaração entra como mais um ano: nada é substituído. As tabelas mostram os 4 anos mais recentes; os anteriores continuam aqui. Clique numa declaração para analisar aquele ano.">
    Cada declaração é um ano; clique para analisar aquele ano.
  </p>
</div>
